import { render, staticRenderFns } from "./dialogAddVip.vue?vue&type=template&id=79b92eb7&scoped=true&"
import script from "./dialogAddVip.vue?vue&type=script&lang=js&"
export * from "./dialogAddVip.vue?vue&type=script&lang=js&"
import style0 from "./dialogAddVip.vue?vue&type=style&index=0&id=79b92eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b92eb7",
  null
  
)

export default component.exports